/**
 * Whether a locale gets the legal convenience-translation notice.
 *
 * Its own module rather than an export beside the component, because two
 * separate things read it: the notice, which renders itself, and `LegalPage`,
 * which lays out AROUND it.
 *
 * That second reader is why it exists at all. `LegalPage` wrapped the notice
 * and the last-updated stamp in a `mb-8` row, and on an English page with no
 * dated instrument both children render nothing — so the row became an empty
 * box holding 32px of margin open. Measured on four trust documents, where it
 * read as a gap somebody had forgotten to fill. A layout decision that depends
 * on whether a child will render must read the same predicate the child does,
 * or the two drift silently and only one of them is visible.
 */
export function showsTranslationNotice(locale: string): boolean {
  return locale !== 'en';
}
